import React, { useState, useEffect } from 'react';
import { motion,AnimatePresence } from "framer-motion"
import axios from 'axios';
import Logo from './logo';
import Confirm from './confirm';
import './style.scss';

function App() {

  useEffect(() => {
    console.log('IN')
    setTimeout(()=>setisVisible(true), 500);
  }, [])
  
  const [formData, setformData] = useState({
    _id:'',
    email:'',
    tracking:'',
    name:'',
    phone:''
  });

  const spinTransition = {
    loop: Infinity,
    ease: "linear",
    duration: 1
  };
  const circleStyle = {
    display: "block",
    width: "1.5rem",
    height: "1.5rem",
    border: "0.3rem solid #e9e9e9",
    borderTop: "0.3rem solid #fe8713",
    borderRadius: "50%",
    position: "absolute",
    boxSizing: "border-box",
    top: 0,
    left: 0
  };

  const [isVisible, setisVisible] = useState(false);
  const [emailError, setemailError] = useState(false);
  const [nameError, setnameError] = useState(false);
  const [phoneError, setphoneError] = useState(false);
  const [loading, setloading] = useState(false);
  const [Complete, setComplete] = useState(false);
  const [step, setStep] = useState(0);

  const isValidEmail = (email) => {
    var validRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

        if (email.match(validRegex)) {

          return true;

        } else {

          return false;

        }
      
  }


  const _handleEmail = (e) =>{
    setformData({...formData,email:e.target.value})
  }

  const _handlePhone = (e) =>{
    let phone = e.target.value;
    phone = phone.replace(/[A-Za-z]/g, "").replace(/\s/g, '');
    setformData({...formData,phone})
  }

  const _handleTracking = (e) =>{
   
    var numbers = /^[0-9]+$/;
      if(e.target.value.match(numbers)){ setformData({...formData,tracking:e.target.value}) }
  }

  const _handleName = (e) =>{
    setformData({...formData,name:e.target.value})
  }

  const handleSubmit = event => {
    event.preventDefault();
    if(step === 0){
     // axios.post(`http://localhost:5000/api/tracking/check`, { ...formData })
     setloading(true)
      axios.post(`https://api-logistic.cardinal.dev/api/tracking/check`, { ...formData })
      .then(res => {
        setloading(false);
        if(res.status === 200){

          setformData({...formData,_id:res.data._id});
          setStep(1);

        }else{
          //show error ID not exist
          setformData({...formData,_id:''});
          setStep(1);
        }
      });

    }else if(step ===1){

      
      if(formData.name.length <= 4){
        setnameError(true);
        return;
      }else{
        setnameError(false);
        setStep(2);
      }

    }else if(step ===2){

      //check email
      if(!isValidEmail(formData.email)){
        setemailError(true);
        return;
      }else if(formData.phone.length <= 9){
        setphoneError(true);
        return;
      }else{
        setemailError(false); setphoneError(false);
        setloading(true);
         // axios.post(`http://localhost:5000/api/tracking/confirm`, { ...formData })
        axios.post(`https://api-logistic.cardinal.dev/api/tracking/confirm`, { ...formData })
        .then(res => {
          setloading(false);
          if(res.status === 200){
            setStep(3);
            setComplete(true)
          }else{
            //show error ID not exist

          }
        })
      }

    }
      
  }

  return (
    <motion.div
    animate={{
            scale: [0.2, 0.8,1],
            borderRadius:['100%','100%','0%'],
            opacity:["0%","20%","100%"],
          }}
    //transition={{ ease: "easeOut", duration: 0.5 }}
    transition={{
           // delay: 1,
           
            x: { type: "spring", stiffness: 100 },
            default: { duration: 0.5 },
          }}
    className="container-fluid p-0" style={{backgroundColor:"#f1f1ef"}}>
    <div className="row align-items-center" style={{minHeight: "100vh",margin:0}}>
      <AnimatePresence>
          {isVisible && !Complete && (<>
                      <motion.div animate={{
                        //borderRadius: ["100%", "0%"],
                        scale: [0.98,1,1],
                        y:[20,-10,0],
                        opacity:["0%","100%","100%"],
                      }}
                      initial={{ opacity:0 }}
                      // transition={{ ease: "easeIn", duration: 0.3 }}
                      transition={{ x: { type: "spring", stiffness: 100 },default: { duration: 0.5 } }}
                      className='offset-md-3 col-md-3 align-self-center text-start p-3 shadow-sm bg-white' style={{borderRadius:15,position:'relative'}}>
                      {loading &&(<div style={{position:'absolute',right:30,top:10}}>
                        <motion.span
                          style={circleStyle}
                          animate={{ rotate: 360 }}
                          transition={spinTransition}
                        /></div>)}
                        <div className="mb-1 align-items-center d-flex" style={{height:45}}>
                          <span className='d-inline align-center'><Logo width={20} height={27} /></span>
                          <p className="d-inline align-center m-0 ms-3" style={{fontSize:24}}>Notificaciones</p>
                        </div>
                      
                      <p style={{fontSize:12}}>Ingrese su N° de Orden para que podamos informarle los cambios de estado. Este mismo se encuentra en el detalle de compra de MercadoLibre.</p>
                      <form onSubmit={handleSubmit}>
                      {step === 0 && (
                        <AnimatePresence>
                        <motion.div
                        animate={{
                        //borderRadius: ["100%", "0%"],
                        scale: [0.9,1],
                        x:[-10,0],
                        opacity:["0%","100%"],
                          }}
                        transition={{ x: { type: "spring", stiffness: 100 },default: { duration: 0.5 } }}
                        className="form-group mb-4">
                          <label className='mb-1'>Número de Orden</label>
                          <input type="text" className="form-control" placeholder="N° de orden" value={formData.tracking} onChange={_handleTracking} />
                        {/* <small id="emailHelp" className="form-text text-muted">We'll never share your email with anyone else.</small>*/}
                        </motion.div>
                        

                        </AnimatePresence>
                      )}
                      {step === 1 && (
                        <AnimatePresence>
                        <motion.div
                        animate={{
                        //borderRadius: ["100%", "0%"],
                        scale: [0.9,1],
                        x:[-10,0],
                        opacity:["0%","100%"],
                          }}
                        transition={{ x: { type: "spring", stiffness: 100 },default: { duration: 0.5 } }}
                        className="form-group mb-4">
                        <label className='mb-1'>Nombre</label>
                        <input type="text" className={nameError?"form-control is-invalid" : "form-control"} placeholder="Ingrese su Nombre" value={formData.name} onChange={_handleName} />
                      </motion.div></AnimatePresence>
                      )}
                      {step === 2 && (
                        <AnimatePresence>
                        <motion.div
                        key='email'
                        animate={{
                        //borderRadius: ["100%", "0%"],
                        scale: [0.9,1],
                        x:[-10,0],
                        opacity:["0%","100%"],
                          }}
                        transition={{ x: { type: "spring", stiffness: 100 },default: { duration: 0.5 } }}
                        className="form-group mb-4">
                        <label className='mb-1'>Email</label>
                        <input type="email" className={emailError?"form-control is-invalid" : "form-control"} placeholder="Ingrese su email" value={formData.email} onChange={_handleEmail} />
                      </motion.div>
                      <motion.div
                      key='phone'
                        animate={{
                        //borderRadius: ["100%", "0%"],
                        scale: [0.9,1],
                        x:[-10,0],
                        opacity:["0%","100%"],
                          }}
                        transition={{ x: { type: "spring", stiffness: 100 },default: { duration: 0.5 } }}
                        className="form-group mb-4">
                        <label className='mb-1'>Teléfono - ej: 1154445555</label>
                        <input type="text" name='phone' className={phoneError?"form-control is-invalid" : "form-control"} placeholder="Teléfono" value={formData.phone} onChange={_handlePhone} />
                      </motion.div>
                      </AnimatePresence>
                      )}
                      <button type="submit" disabled={loading} className="btn btn-primary text-white btn-block w-100" style={{position:'relative'}}>Validar <span style={{position:'absolute',right:10}}>{step+1} / 3</span></button>
                      </form>
                      </motion.div> 
                      <motion.div animate={{
                        scale: [0.98,1,1],
                        y:[20,-10,0],
                        opacity:["0%","100%","100%"],
                      }} initial={{ opacity:0 }}
                      transition={{ x: { type: "spring", stiffness: 100 },default: { duration: 0.5 } }}
                      className='col-md-auto p-3 m-md-2 shadow-sm bg-white' style={{borderRadius:15,position:'relative',alignContent:'center',alignItems:'center'}}>
                        <img src={require('./example.jpg')} className='img-fluid rounded mx-auto' style={{alignSelf:'center'}} alt="MELI" />
                      </motion.div></>
                  )}
                  </AnimatePresence>             
             {Complete && (
                    <AnimatePresence>
                      <motion.div animate={{
                        //borderRadius: ["100%", "0%"],
                        scale: [0.98,1,1],
                        y:[20,-10,0],
                        opacity:["0%","100%","100%"],
                      }}
                      initial={{ opacity:0 }}
                    // transition={{ ease: "easeIn", duration: 0.3 }}
                    transition={{ x: { type: "spring", stiffness: 100 },default: { duration: 0.5 } }}
                      className='col-md-3 align-self-center m-auto text-center p-3 bg-success shadow-sm' style={{borderRadius:15,position:'relative'}}>

                      <AnimatePresence>
                        <motion.div
                        animate={{
                        //borderRadius: ["100%", "0%"],
                        scale: [0.9,1],
                        x:[-10,0],
                        opacity:["0%","100%"],
                          }}
                        transition={{ x: { type: "spring", stiffness: 100 },default: { duration: 0.5 } }}
                        className="form-group mb-1 mt-3 text-center">
                         <Confirm width={120} height={120} />
                      </motion.div></AnimatePresence>

                      <p className="align-center m-0 mb-2" style={{fontSize:24}}>Muchas Gracias</p>
                      <p className='text-white' style={{fontSize:12}}>El proceso ha sido completado, en cuanto el paquete entre en ruta, le avisaremos el tiempo de llegada.</p>
                      
                      </motion.div></AnimatePresence>
                  )}    
    </div>
  </motion.div>
  
  );
}

export default App;
